import { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { StyledTable } from 'components'
import { useCountryTableColumns } from 'domains/Country/hooks'

const CountryTable = (props) => {
  const { dataSource } = props
  /* Pagination params for table */
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showQuickJumper: true,
    showSizeChanger: true
  })

  /* Getting table columns */
  const columns = useCountryTableColumns()

  /* Handle changes for table */
  const handleTableChange = (pagination) => setTableParams(pagination)

  /* Update total value for tableParams */
  useEffect(() => {
    dataSource?.length &&
      setTableParams((prev) => ({
        ...prev,
        total: dataSource?.length
      }))
  }, [dataSource])

  return (
    <StyledTable
      {...props}
      rowKey="_id"
      columns={columns}
      pagination={tableParams}
      onChange={handleTableChange}
    />
  )
}
CountryTable.propTypes = {
  dataSource: PropTypes.array
}

export default CountryTable
